import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'vasektomie',
  templateUrl: './vasektomie.component.html',
  styleUrls: ['./vasektomie.component.sass']
})
export class VasektomieComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
